import axios from 'axios';
import {
  CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_BEGIN,
  CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_SUCCESS,
  CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_FAILURE,
  CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectDetailCustomComponent(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectDetailCustomComponentError() {
  return {
    type: CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_BEGIN:
      return {
        ...state,
        loadProjectDetailCustomComponentPending: true,
        loadProjectDetailCustomComponentError: null,
      };

    case CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_SUCCESS:
      return {
        ...state,
        loadProjectDetailCustomComponentPending: false,
        loadProjectDetailCustomComponentError: null,
        projectDetail: action.data,
      };

    case CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_FAILURE:
      return {
        ...state,
        loadProjectDetailCustomComponentPending: false,
        loadProjectDetailCustomComponentError: action.data.error,
      };

    case CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_DISMISS_ERROR:
      return {
        ...state,
        loadProjectDetailCustomComponentError: null,
      };

    default:
      return state;
  }
}
